import { css } from '@emotion/core'

export const styles = {
  container: css`
    width: 100%;

    /* background: rgb(252, 252, 252); */
    background: white;
    padding: 50px 0;

    display: flex;
    flex-direction: row;
    justify-content: space-evenly;
  `,

  section: css`
    display: flex;
    flex-direction: column;
    align-items: flex-start;
  `,

  title: css`
    font-size: 12px;
    font-weight: 800;
    text-transform: uppercase;
    color: #777777;

    margin: 0 0 18px 0;
  `,

  subtitle: css`
    font-size: 10px;
    margin-top: -8px;
    opacity: 0.75;
  `,

  item: css`
    font-size: 13px;
    font-weight: 600;
    color: #22303d;
    opacity: 0.8;
    text-decoration: none;

    margin-bottom: 8px;

    &:hover {
      text-decoration: underline;
      text-decoration-color: rgb(0, 0, 0, 0.5);
    }
  `,
}
